import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  SettingOutlined,
  FolderOpenOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@ant-design/icons";
import Notiflix from "notiflix";
import { connect, useDispatch } from "react-redux";

import {
  DatePicker,
  Input,
  Row,
  Typography,
  Card,
  Select,
  Col,
  Form,
  Table,
  Dropdown,
  Divider,
  Button,
  Anchor,
  Descriptions,
  Spin,
  Statistic,
} from "antd";

//OTHER IMPORTS
import dayjs from "dayjs";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import {
  apiConfig,
  labelConfig,
  staticConfig,
} from "../../configurations/configurations.config";
import { rightAction } from "../../../redux/actions";
import CustomButton from "../../../components/custom/CustomButton";

const { Link } = Anchor;
const { Text } = Typography;

const DetailSchedulerJobs = (props) => {
  const { userData } = props;
  const { session } = userData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [schedulerJobsDetail, setSchedulerJobsDetail] = useState([]);
  const [menuProps, setMenuProps] = useState({
    items: [],
  });

  useEffect(() => {
    getDetailById();
  }, []);

  function getDetailById() {
    const url = `${apiConfig.Jobs}/${state.id}`;

    let body = {
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
      } else {
        setIsLoading(false);
        const objList = res;
        setSchedulerJobsDetail(objList);

        setMenuProps({
          items: handleActionButton(objList),
          onClick: (e) => {
            const item = handleActionButton(objList).find(
              (element) => element.key === e.key
            );

            if (item) {
              return navigate(item.route, {
                state: {
                  ...state,
                  actionLabel: item.label,
                },
              });
            }
          },
        });
      }
    });
  }

  const handleActionButton = (accDetail) => {
    return [
      {
        label: "View History",
        key: "1",
        route: "/view-history",
        // disabled: !BOM.HasPermission("CREATE_LOANCHARGE"),
        icon: <SettingOutlined />,
      },
    ];
  };

  function onCancel() {
    navigate("/manage-scheduler-jobs");
  }



  const items = [
    {
      key: "2",
      label: labelConfig.jobName,
      children: schedulerJobsDetail
        ? schedulerJobsDetail.displayName
        : "Not Available",
    },
    {
      key: "3",
      label: labelConfig.cronExpression,
      children: schedulerJobsDetail
        ? schedulerJobsDetail.cronExpression
        : "Not Available",
    },
    {
      key: "4",
      label: labelConfig.isActiveJob,
      children:
        schedulerJobsDetail?.active === true ? "True" : "False",
    },

    {
      key: "5",
      label: labelConfig.follow,
      children: (
        <Link
          target="_blank"
          href={process.env.REACT_APP_CRONJOB_BASE_URL_DEVELOPMENT}
          title="Click Here To Generate Cron Expression"
        />
      ),
    },
  ];

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailSchedulerJobs}
        pageItems={staticConfig.detailSchedulerJobsBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical">
            <Row style={{ marginBottom: 30, padding: 10 }}>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button
                  menu={menuProps}
                  icon={<SettingOutlined />}
                  placement="topLeft"
                >
                  Action
                </Dropdown.Button>
              </Col>
            </Row>

            <Row>
              <Col span={24}>
                <Descriptions
                  bordered
                  column={{ xs: 1, sm: 2, md: 2, lg: 2, xl: 2, xxl: 2 }}
                  style={{ marginTop: 10, marginBottom: 20 }}
                  items={items}
                />
              </Col>
            </Row>

            <Row>
              <Divider />
              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: "auto",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default DetailSchedulerJobs;
